import { useEffect, useState } from "react";
import * as basicUserApi from "../../../services/basic.service";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../../common/breadcrumbs";
import { formateDate, showStatus } from "../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { Placeholder } from "rsuite";

const BasicUserView = () => {
    const params = useParams()
    const [showdefault, setShowDefault] = useState({});
    const { t } = useTranslation();
    const navigate = useNavigate();

    const breadcrumbs = [
        { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
        { title: t("Basic User"), url: "/admin/user-management/basic-user/list/1" },
        { title: t("btn_view"), url: "" }
    ]

    useEffect(() => {
        basicUserApi
            .Details(params.id)
            .then((response) => {
                setShowDefault(response && response?.data);
            })
    }, [])

    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <div className="row row-sm">
                <div className="col-lg-12 col-md-12 animation_fade">
                    <div className="card custom-card">
                        <div className="card-body">
                            <div>
                                <h6 className="main-content-label mb-3">Basic View</h6>
                            </div>

                            {showdefault && Object.keys(showdefault)?.length > 0 ? (
                                <div className="row">
                                    <div className="col-lg-12 form-group">
                                        <table id="simple-table" className="table table-bordered table-hover">
                                            <tbody>
                                                {/* Player Info */}
                                                <tr>
                                                    <th>{t("label_name")}</th>
                                                    <td className="text-capitalize">
                                                        {showdefault.firstName || "N/A"} {showdefault.lastName || "N/A"}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("label_email")}</th>
                                                    <td>{showdefault.email || "N/A"}</td>
                                                </tr>
                                                <tr>
                                                    <th>{t("list_heading_status")}</th>
                                                    <td>
                                                        {showdefault?.status ? (
                                                            <span
                                                                className={`badge badge-pill fw-bold text-uppercase px-3 py-2 ${{
                                                                        active: "badge-success-light",
                                                                        inactive: "badge-danger-light",
                                                                    }[showdefault.status.toLowerCase()] || "badge-secondary"
                                                                    }`}
                                                            >
                                                                {showdefault.status}
                                                            </span>
                                                        ) : (
                                                            "N/A"
                                                        )}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <th>{t("list_heading_created_date")}</th>
                                                    <td>{formateDate(showdefault.createdAt) || "N/A"}</td>
                                                </tr>
                                                <tr>
                                                    <th>{t("label_modified_date")}</th>
                                                    <td>{formateDate(showdefault.updatedAt) || "N/A"}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div className="mt-5">
                                            <button
                                                className="btn ripple btn-dark"
                                                type="button"
                                                onClick={() => navigate(-1)}
                                            >
                                                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                                                {t("btn_back")}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7} />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BasicUserView;
